'use strict';

var Collection = require('base/Colido.Collection');
var SubtypeModel = require('../models/subtype');

/**
 * Collection for the currencies
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Augusto Campos-Leiva <augusto@campos-leiva.de>
 */
var SubtypesCollection = Collection.extend({
    api: '/core/subtypes',
    name: 'global:subtypes',
    model: SubtypeModel,
});

module.exports = SubtypesCollection;